var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "homepage" },
    [
      _c("Alerts", { attrs: { "alert-type": "alert_homepage" } }),
      _c(
        "section",
        {
          staticClass: "section d-flex justify-content-center desktop-picture",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "col-lg-9 authorized-distributor-wrapper d-lg-flex d-md-flex d-sm-block",
              class: _vm.isMobile()
                ? "justify-content-center"
                : "justify-content-end",
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-content-center flex-column" },
                [
                  _vm._m(0),
                  _c("p", { staticClass: "text-center heading-medium" }, [
                    _vm._v(_vm._s(_vm.$t("homepage_authorized_distributor"))),
                  ]),
                ]
              ),
            ]
          ),
          _c("div", { staticClass: "container-medium first-container" }, [
            _c("h1", { staticClass: "heading text-center" }, [
              _vm._v(_vm._s(_vm.$t("homepage_buy_tpf_erv"))),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "d-lg-flex d-md-flex d-sm-block d-block justify-content-center",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "align-items-center text-center purple-btn mobile-padding-bottom",
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "d-flex justify-content-end",
                        attrs: { to: { name: "vignette" } },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-lg btn-homepage btn-purple",
                            attrs: { dusk: "order-vignette", type: "button" },
                          },
                          [_vm._v(_vm._s(_vm.$t("i_want_vignette")))]
                        ),
                      ]
                    ),
                    _vm._m(1),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "align-items-center text-center purple-btn mobile-padding-bottom",
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "d-flex justify-content-end",
                        attrs: { to: { name: "toll" } },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-lg btn-homepage btn-purple",
                            attrs: { dusk: "order-bridge-fee", type: "button" },
                          },
                          [_vm._v(_vm._s(_vm.$t("i_want_toll")))]
                        ),
                      ]
                    ),
                    _vm._m(2),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "align-items-center text-center purple-btn" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "d-flex justify-content-end",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.brokerNetService.goToBrokerNet()
                          },
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-lg btn-homepage btn-purple",
                            attrs: { dusk: "order-bridge-fee", type: "button" },
                          },
                          [_vm._v(_vm._s(_vm.$t("i_want_insurance")))]
                        ),
                      ]
                    ),
                    _vm._m(3),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm.isLoggedIn == false
        ? _c(
            "section",
            {
              staticClass:
                "login-home-page justify-content-center d-none d-xl-block d-lg-block",
            },
            [_c("LoginComponentHomePage")],
            1
          )
        : _vm._e(),
      _c(
        "section",
        {
          staticClass:
            "grey-bg justify-content-center d-block d-lg-block parteners-section",
          class: { "no-padding-top": !_vm.isLoggedIn },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "partners-container" }, [
              _c("p", { staticClass: "heading-medium" }, [
                _vm._v(_vm._s(_vm.$t("homepage_partners"))),
              ]),
              _vm._m(4),
            ]),
          ]),
        ]
      ),
      _c("section", { staticClass: "section-wrapper" }, [
        _c("div", { staticClass: "container container-small" }, [
          _c("div", { staticClass: "steps" }, [
            _c("p", { staticClass: "heading-medium text-center" }, [
              _vm._v(_vm._s(_vm.$t("homepage_ready_for_road"))),
            ]),
            _c(
              "div",
              { staticClass: "steps-wrapper d-flex justify-content-center" },
              [
                _c("div", { staticClass: "add-cart-wrapper" }, [
                  _vm._m(5),
                  _c("p", { staticClass: "heading-small text-center" }, [
                    _vm._v(_vm._s(_vm.$t("homepage_order"))),
                  ]),
                ]),
                _vm._m(6),
                _c("div", { staticClass: "card-payment-wrapper text-center" }, [
                  _vm._m(7),
                  _c("p", { staticClass: "heading-small text-center" }, [
                    _vm._v(_vm._s(_vm.$t("homepage_payment"))),
                  ]),
                ]),
                _vm._m(8),
                _c("div", { staticClass: "semafor-wrapper text-center" }, [
                  _vm._m(9),
                  _c("p", { staticClass: "heading-small text-center" }, [
                    _vm._v(_vm._s(_vm.$t("homepage_drive"))),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm.isMobile()
        ? _c("section", { staticClass: "section-wrapper pt-0" }, [
            _c("div", { staticClass: "container container-medium" }, [
              _c(
                "div",
                { staticClass: "benefits" },
                [
                  _c("p", { staticClass: "text-center heading-medium" }, [
                    _vm._v(_vm._s(_vm.$t("homepage_your_advantages"))),
                  ]),
                  _c(
                    "carousel",
                    { attrs: { "per-page": 1, "mouse-drag": false } },
                    [
                      _c("slide", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "row steps-wrapper d-lg-flex d-md-flex d-sm-block d-block justify-content-center",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-4 add-cart-wrapper text-center",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "icon verifici-valabilitate-icon",
                                    }),
                                  ]
                                ),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "heading heading-small pt-2 check-validity",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("homepage_vignette_availability")
                                      )
                                    ),
                                  ]
                                ),
                                _c("p", { staticClass: "reading" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "homepage_vignette_availability_description_1"
                                      )
                                    )
                                  ),
                                  _c("br"),
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.openVerifyVignetteModal.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "homepage_vignette_availability_description_2"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-4 card-payment-wrapper text-center",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "icon salveaza-datele-icon",
                                    }),
                                  ]
                                ),
                                _c(
                                  "h3",
                                  { staticClass: "heading heading-small" },
                                  [_vm._v(_vm._s(_vm.$t("homepage_save_data")))]
                                ),
                                _c("p", { staticClass: "reading" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("homepage_save_data_description")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-4 semafor-wrapper text-center",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "icon livrare-email-sms-icon",
                                    }),
                                  ]
                                ),
                                _c(
                                  "h3",
                                  { staticClass: "heading heading-small" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("homepage_sms_email_delivery")
                                      )
                                    ),
                                  ]
                                ),
                                _c("p", { staticClass: "reading" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "homepage_sms_email_delivery_description"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _c("slide", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "steps-wrapper d-lg-flex d-md-flex d-sm-block d-block justify-content-center",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-4 add-cart-wrapper text-center",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "icon card-icon",
                                    }),
                                    _c("div", {
                                      staticClass: "icon invoice-icon",
                                      staticStyle: { "margin-left": "-20px" },
                                    }),
                                  ]
                                ),
                                _c(
                                  "h3",
                                  { staticClass: "heading heading-small" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("homepage_card_or_op"))
                                    ),
                                  ]
                                ),
                                _c("p", { staticClass: "reading" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("homepage_card_or_op_description")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-4 card-payment-wrapper text-center",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "icon notificare-expirare-icon",
                                    }),
                                  ]
                                ),
                                _c(
                                  "h3",
                                  { staticClass: "heading heading-small" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("homepage_notify_expiry"))
                                    ),
                                  ]
                                ),
                                _c("p", { staticClass: "reading" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "homepage_notify_expiry_description"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-4 semafor-wrapper text-center",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "icon servicii-profesioniste-icon",
                                    }),
                                  ]
                                ),
                                _c(
                                  "h3",
                                  { staticClass: "heading heading-small" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("homepage_professional_services")
                                      )
                                    ),
                                  ]
                                ),
                                _c("p", { staticClass: "reading" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "homepage_professional_services_description"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      !_vm.isMobile()
        ? _c("section", { staticClass: "section-wrapper pt-0" }, [
            _c("div", { staticClass: "container container-medium" }, [
              _c("div", { staticClass: "benefits" }, [
                _c("p", { staticClass: "text-center heading-medium" }, [
                  _vm._v(_vm._s(_vm.$t("homepage_your_advantages"))),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "row steps-wrapper d-lg-flex d-md-flex d-sm-block d-block justify-content-center",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-lg-4 add-cart-wrapper text-center" },
                      [
                        _vm._m(10),
                        _c(
                          "h3",
                          {
                            staticClass: "heading heading-small check-validity",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("homepage_vignette_availability"))
                            ),
                          ]
                        ),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "homepage_vignette_availability_description_1"
                              )
                            )
                          ),
                          _c("br"),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.openVerifyVignetteModal.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "homepage_vignette_availability_description_2"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-4 card-payment-wrapper text-center",
                      },
                      [
                        _vm._m(11),
                        _c("h3", { staticClass: "heading heading-small" }, [
                          _vm._v(_vm._s(_vm.$t("homepage_save_data"))),
                        ]),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(
                            _vm._s(_vm.$t("homepage_save_data_description"))
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 semafor-wrapper text-center" },
                      [
                        _vm._m(12),
                        _c("h3", { staticClass: "heading heading-small" }, [
                          _vm._v(_vm._s(_vm.$t("homepage_sms_email_delivery"))),
                        ]),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("homepage_sms_email_delivery_description")
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "steps-wrapper d-lg-flex d-md-flex d-sm-block d-block justify-content-center",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-lg-4 add-cart-wrapper text-center" },
                      [
                        _vm._m(13),
                        _c("h3", { staticClass: "heading heading-small" }, [
                          _vm._v(_vm._s(_vm.$t("homepage_card_or_op"))),
                        ]),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(
                            _vm._s(_vm.$t("homepage_card_or_op_description"))
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-4 card-payment-wrapper text-center",
                      },
                      [
                        _vm._m(14),
                        _c("h3", { staticClass: "heading heading-small" }, [
                          _vm._v(_vm._s(_vm.$t("homepage_notify_expiry"))),
                        ]),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(
                            _vm._s(_vm.$t("homepage_notify_expiry_description"))
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 semafor-wrapper text-center" },
                      [
                        _vm._m(15),
                        _c("h3", { staticClass: "heading heading-small" }, [
                          _vm._v(
                            _vm._s(_vm.$t("homepage_professional_services"))
                          ),
                        ]),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "homepage_professional_services_description"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "section",
        {
          staticClass:
            "container-fluid section-benefits d-lg-flex d-md-flex d-sm-block d-block",
        },
        [
          _c("div", { staticClass: "row" }, [
            _vm._m(16),
            _c("div", { staticClass: "benefits-wrapper col-lg-6 pl-0 pr-0" }, [
              _c("div", { staticClass: "wrapper-inner" }, [
                _c("p", { staticClass: "heading-medium" }, [
                  _vm._v(_vm._s(_vm.$t("bp_company_advantages"))),
                ]),
                _c("div", { staticClass: "inner col-xl-6 p-0" }, [
                  _c("div", { staticClass: "p-small" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.$t("bp_import_you_cars_through_excel"))
                      ),
                    ]),
                    _vm._v(
                      " " + _vm._s(_vm.$t("homepage_online_assistance")) + " "
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "mt-4",
                      class: _vm.isMobile() ? "justify-content-center" : "",
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "main-btn",
                          attrs: { to: { name: "company-advanges" } },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("homepage_discover_all_benefits"))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c("section", { staticClass: "section-distribuitor" }, [
        _c("div", { staticClass: "container container-medium" }, [
          _c("p", { staticClass: "heading-medium text-center" }, [
            _vm._v(_vm._s(_vm.$t("homepage_discover_all_benefits"))),
          ]),
          _c("div", { staticClass: "align-items-center text-center" }, [
            _vm._m(17),
            _c("p", { staticClass: "mt-1 heading-small" }, [
              _vm._v(_vm._s(_vm.$t("homepage_distribution_points"))),
            ]),
            _c("div", { staticClass: "d-flex justify-content-center" }, [
              _c("p", { staticClass: "puncte-teritoriale-text" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("homepage_authorized_distributor_2")) +
                    " "
                ),
              ]),
            ]),
            _c("p", [
              _c(
                "strong",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "distribution" } } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("homepage_distribution_points_description")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "section-frequent-questions" }, [
        _c(
          "div",
          { staticClass: "container container-small" },
          [
            _c("p", { staticClass: "text-center pb-3 heading-medium" }, [
              _vm._v(_vm._s(_vm.$t("homepage_frequent_questions"))),
            ]),
            _c("FrequentQuestionComponent", {
              attrs: { count: 3, homepage: true },
            }),
            _c("p", [
              _c(
                "strong",
                [
                  _c("router-link", { attrs: { to: { name: "questions" } } }, [
                    _vm._v(
                      _vm._s(_vm.$t("homepage_frequent_questions_description"))
                    ),
                  ]),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon authorized-distributor-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("img", {
        staticClass: "d-flex justify-content-center",
        attrs: { src: require("../media/logo_rovinieta.svg"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("img", {
        staticClass: "d-flex justify-content-center",
        attrs: { src: require("../media/logo_taxa_pod.svg"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("img", {
        staticClass: "d-flex justify-content-center",
        attrs: {
          src: require("../media/logo_tbasigurari.png"),
          height: "20px",
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex flex-wrap partners" }, [
      _c(
        "a",
        {
          staticClass: "main-btn fit-content",
          attrs: { href: "https://untrr.ro", target: "_blank" },
        },
        [_vm._v("www.untrr.ro")]
      ),
      _c(
        "a",
        {
          staticClass: "main-btn fit-content",
          attrs: { href: "https://loimacron.eu", target: "_blank" },
        },
        [_vm._v("www.loimacron.eu")]
      ),
      _c(
        "a",
        {
          staticClass: "main-btn fit-content",
          attrs: { href: "https://transmag.ro", target: "_blank" },
        },
        [_vm._v("www.transmag.ro")]
      ),
      _c(
        "a",
        {
          staticClass: "main-btn fit-content",
          attrs: { href: "https://taxa-pod-fetesti.ro", target: "_blank" },
        },
        [_vm._v("www.taxa-pod-fetesti.ro")]
      ),
      _c(
        "a",
        {
          staticClass: "main-btn fit-content",
          attrs: { href: "https://tuneluri.ro", target: "_blank" },
        },
        [_vm._v("www.tuneluri.ro")]
      ),
      _c(
        "a",
        {
          staticClass: "main-btn fit-content",
          attrs: { href: "https://www.tbasigurari.ro/", target: "_blank" },
        },
        [_vm._v("www.tbasigurari.ro")]
      ),
      _c(
        "a",
        {
          staticClass: "main-btn fit-content",
          attrs: { href: "https://a1formular.ro", target: "_blank" },
        },
        [_vm._v("www.a1formular.ro")]
      ),
      _c(
        "a",
        {
          staticClass: "main-btn fit-content",
          attrs: { href: "https://detasaretransport.ro", target: "_blank" },
        },
        [_vm._v("www.detasaretransport.ro")]
      ),
      _c(
        "a",
        {
          staticClass: "main-btn fit-content",
          attrs: { href: "http://asigurarecmr.ro", target: "_blank" },
        },
        [_vm._v("www.asigurarecmr.ro")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon add-cart-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hr-line-wrapper" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon card-payment-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hr-line-wrapper" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon semafor-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon verifici-valabilitate-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon salveaza-datele-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon livrare-email-sms-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon card-icon" }),
      _c("div", {
        staticClass: "icon invoice-icon",
        staticStyle: { "margin-left": "-20px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon notificare-expirare-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon servicii-profesioniste-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-6 col-img pl-0 pr-0" }, [
      _c("img", { attrs: { src: require("../media/beneficii.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon finder-icon" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }